import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[backcolor]'
})
export class BackgroundColorDirective {

  constructor(private el: ElementRef) { }

  @Input('backcolor') backColor: string;

  ngOnInit() {
    this.highlight(this.backColor || null);
  }

  private highlight(color: string) {
    this.el.nativeElement.style.backgroundColor = color;
  }
}